import { render, staticRenderFns } from "./bw_list.vue?vue&type=template&id=0a555df6&scoped=true&"
import script from "./bw_list.vue?vue&type=script&lang=js&"
export * from "./bw_list.vue?vue&type=script&lang=js&"
import style0 from "./bw_list.vue?vue&type=style&index=0&id=0a555df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a555df6",
  null
  
)

export default component.exports